/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorMonthData', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorDataFilter'), require('../model/PerformanceIndicatorMonthData'), require('../model/CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorMonthDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorDataFilter, root.ForStractionServiceApi.PerformanceIndicatorMonthData, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, PerformanceIndicatorDataFilter, PerformanceIndicatorMonthData, CorporateStructureLink) {
  'use strict';

  /**
   * PerformanceIndicatorMonthData service.
   * @module api/PerformanceIndicatorMonthDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorMonthDataApi. 
   * @alias module:api/PerformanceIndicatorMonthDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataClearPut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataClearPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clear
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataClearPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorMonthDataClearPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataClearPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataClearPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/clear', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataMergeAllPut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorMonthData>} body 
     * @param {Boolean} rollOverLevels 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.aggregationLevelID 
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceIndicatorMonthDataMergeAllPut = function(_4SAPIAppID, body, rollOverLevels, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataMergeAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataMergeAllPut";
      }

      // verify the required parameter 'rollOverLevels' is set
      if (rollOverLevels == undefined || rollOverLevels == null) {
        throw "Missing the required parameter 'rollOverLevels' when calling performanceIndicatorMonthDataMergeAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rollOverLevels': rollOverLevels,
        'aggregationLevelID': opts['aggregationLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/mergeAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataMergeTargetActualValuePut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetActualValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetActualValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} indicatorID 
     * @param {Number} actual 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetActualValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorMonthDataMergeTargetActualValuePut = function(_4SAPIAppID, body, year, month, indicatorID, actual, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorMonthDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorMonthDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorMonthDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'actual' is set
      if (actual == undefined || actual == null) {
        throw "Missing the required parameter 'actual' when calling performanceIndicatorMonthDataMergeTargetActualValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'indicatorID': indicatorID,
        'actual': actual,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/mergeTargetActualValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataMergeTargetBudgetValuePut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetBudgetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetBudgetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} indicatorID 
     * @param {Number} budget 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetBudgetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorMonthDataMergeTargetBudgetValuePut = function(_4SAPIAppID, body, year, month, indicatorID, budget, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorMonthDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorMonthDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorMonthDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'budget' is set
      if (budget == undefined || budget == null) {
        throw "Missing the required parameter 'budget' when calling performanceIndicatorMonthDataMergeTargetBudgetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'indicatorID': indicatorID,
        'budget': budget,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/mergeTargetBudgetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataMergeTargetForecastValuePut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetForecastValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetForecastValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} indicatorID 
     * @param {Number} forecast 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetForecastValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorMonthDataMergeTargetForecastValuePut = function(_4SAPIAppID, body, year, month, indicatorID, forecast, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorMonthDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorMonthDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorMonthDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'forecast' is set
      if (forecast == undefined || forecast == null) {
        throw "Missing the required parameter 'forecast' when calling performanceIndicatorMonthDataMergeTargetForecastValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'indicatorID': indicatorID,
        'forecast': forecast,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/mergeTargetForecastValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataMergeTargetGoalValuePut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetGoalValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetGoalValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} indicatorID 
     * @param {Number} goal 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetGoalValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorMonthDataMergeTargetGoalValuePut = function(_4SAPIAppID, body, year, month, indicatorID, goal, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorMonthDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorMonthDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorMonthDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'goal' is set
      if (goal == undefined || goal == null) {
        throw "Missing the required parameter 'goal' when calling performanceIndicatorMonthDataMergeTargetGoalValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'indicatorID': indicatorID,
        'goal': goal,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/mergeTargetGoalValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataMergeTargetValuePut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} month 
     * @param {Integer} indicatorID 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.actual 
     * @param {Number} opts.goal 
     * @param {Number} opts.budget 
     * @param {Number} opts.forecast 
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataMergeTargetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorMonthDataMergeTargetValuePut = function(_4SAPIAppID, body, year, month, indicatorID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataMergeTargetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataMergeTargetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorMonthDataMergeTargetValuePut";
      }

      // verify the required parameter 'month' is set
      if (month == undefined || month == null) {
        throw "Missing the required parameter 'month' when calling performanceIndicatorMonthDataMergeTargetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorMonthDataMergeTargetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'month': month,
        'indicatorID': indicatorID,
        'actual': opts['actual'],
        'goal': opts['goal'],
        'budget': opts['budget'],
        'forecast': opts['forecast'],
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/mergeTargetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorMonthDataSearchPut operation.
     * @callback module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorMonthData>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorMonthData>} body 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/PerformanceIndicatorMonthDataApi~performanceIndicatorMonthDataSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorMonthData>}
     */
    this.performanceIndicatorMonthDataSearchPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorMonthDataSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorMonthDataSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorMonthData];

      return this.apiClient.callApi(
        '/PerformanceIndicatorMonthData/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
